import { render, staticRenderFns } from "./ModuleTree.vue?vue&type=template&id=dd7deb92&scoped=true&"
import script from "./ModuleTree.vue?vue&type=script&lang=js&"
export * from "./ModuleTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7deb92",
  null
  
)

export default component.exports